import React, { useEffect, useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, setEditDataCreator, updateFieldCreator } from './reducer';
import {
  setIpmaCisEditErrorsCreator,
  updateIpmaCisCreator,
} from '../../../../../store/actionsCreators';
import { globalPropTypes } from 'helpers';
import EditCertificateHolder from '../../../../../shared/Cis/CertificateHolders/Edit/EditCertificateHolder';

const EditIpmaCertificateHolder = ({
  certificateHolder,
  errors,
  updateCertificateHolder,
  removeError,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  useEffect(() => {
    if (certificateHolder) {
      dispatch(setEditDataCreator(certificateHolder));
    }
  }, [certificateHolder]);

  return (
    <EditCertificateHolder 
    state={state}
    dispatch={dispatch}
    updateFieldCreator={updateFieldCreator}
    errors={errors}
    updateCertificateHolder={updateCertificateHolder}
    removeError={removeError}
    />
  )
};

EditIpmaCertificateHolder.propTypes = {
  certificateHolder: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    middleName: PropTypes.string,
    birthDate: PropTypes.any,
    status: PropTypes.number,
  }),
  errors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    middleName: PropTypes.string,
    birthDate: PropTypes.string,
    status: PropTypes.string,
  }),
  updateCertificateHolder: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

EditIpmaCertificateHolder.defaultProps = {
  errors: {},
};

const mapStateToProps = ({ ipma, globals }) => ({
  errors: ipma.cis.certificateHolders.editErrors,
  certificateHolder: ipma.cis.certificateHolders.profile,
});

const mapDispatchToProps = (dispatch) => ({
  updateCertificateHolder: (id, payload, history) =>
    dispatch(updateIpmaCisCreator(id, 'certificateHolders', payload, history)),
  removeError: (payload) => dispatch(setIpmaCisEditErrorsCreator('certificateHolders', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditIpmaCertificateHolder);
